import React from 'react';
import './StyledInput.css';

const StyledInput = ({ 
  value, 
  onChange, 
  label, 
  placeholder, 
  type = 'text',
  icon,
  variant = 'default' // default, flight, accommodation, destination, budget
}) => {
  const getIcon = () => {
    if (icon) return icon;
    
    switch (variant) {
      case 'flight':
        return '✈️';
      case 'accommodation':
        return '🏠';
      case 'destination':
        return '📍';
      case 'budget':
        return '💰';
      default:
        return null;
    }
  };

  const inputIcon = getIcon();

  return (
    <div className={`styled-input-wrapper ${variant}`}>
      <label className="styled-input-label">{label}</label>
      <div className="styled-input-container">
        {inputIcon && (
          <div className="styled-input-icon">
            {inputIcon}
          </div>
        )}
        <input
          type={type}
          className="styled-input"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default StyledInput;

